export default __webpack_public_path__ + "e1a6fb6d85caf90b098afebae135a583.glb";